export default __webpack_public_path__ + "static/media/completeReg.87268095.png";